import axios from '../axios'

export default class ActivityService {


  async getAllSalesData(pageNo=1,pageSize=100000) {
    var path = `v1/allSalesData/${pageNo}/${pageSize}`
    var response = await axios.get(path)
    return response
  }

  deleteSalesForecast(id)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/delSalesForecast/' + id
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteActualSales(id)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/delActualSales/' + id
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  addForecastByYear(obj) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/addforecastbyyear'
        var response = await axios.post(path, obj)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  addSalesByYear(obj) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/addsalesbyyear'
        var response = await axios.post(path, obj)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerIdForBranch(sCustCode, sBranch)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getCustIdForBranch'
        var response = await axios.post(path, {
          'mbpBranch': sBranch,
          'custCode': sCustCode
        })
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  postForeCast(obj)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/addforecast'
        var response = await axios.post(path, obj)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  postSales(obj)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/addsales'
        var response = await axios.post(path, obj)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteSales(year, month)  {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/deletesales/' + year + '/' + month
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllSalesForcast() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/allsalesforecasts'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActualSales() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/allactualsales'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActualSalesByLazyLoad(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/actualsalesfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllSalesForcastByLazyLoad(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/forecastfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}